import React from 'react';

export default ({ time }) => {
    const seconds = padLeft(time % 60, '00');
    const minutes = padLeft(~~(time / 60) % 60, '00');
    const hours = ~~(time / 3600);

    const timeStr = (hours ? hours + ':' : '') + minutes + ':' + seconds;

    return <span>{timeStr}</span>;

    function padLeft(value, padding) {
        return (padding + value.toString()).slice(-padding.length);
    }
}
